var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.502,
    height: 43.5,
    viewBox: "0 0 43.502 43.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customers",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(14.5 9.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M170.124,109.828a3.589,3.589,0,0,0,.758-2.193,3.625,3.625,0,0,0-7.25,0,3.589,3.589,0,0,0,.758,2.193,4.74,4.74,0,0,0-4.383,4.719v6.138a.725.725,0,0,0,.725.725h2.175v9.425a.725.725,0,0,0,.725.725h7.25a.725.725,0,0,0,.725-.725h0V121.41h2.175a.725.725,0,0,0,.725-.725h0v-6.138A4.74,4.74,0,0,0,170.124,109.828Zm-2.867-4.368a2.175,2.175,0,1,1-2.175,2.175A2.175,2.175,0,0,1,167.257,105.46Zm5.8,14.5h-1.45v-6.525h-1.45V130.11h-2.175v-9.425h-1.45v9.425h-2.175V113.435h-1.45v6.525h-1.45v-5.413a3.291,3.291,0,0,1,3.287-3.287h5.025a3.291,3.291,0,0,1,3.287,3.287v5.413Z",
    transform: "translate(-160.007 -104.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(28.488 0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M327.121,1.227a5.8,5.8,0,0,0-8.133,8.133L314.351,14l1.025,1.025,4.637-4.637a5.8,5.8,0,0,0,7.108-9.158Zm-3.557,6.758a.726.726,0,0,1-.725-.725h-1.45a2.171,2.171,0,0,0,1.45,2.041v.793a4.345,4.345,0,0,1,0-8.569v.793a2.172,2.172,0,0,0-1.45,2.041c0,1.53,1.226,1.912,1.958,2.141.818.255.942.355.942.759A.726.726,0,0,1,323.564,7.985Zm4.29-1.456a4.344,4.344,0,0,1-3.565,3.565V9.3a2.171,2.171,0,0,0,1.45-2.041c0-1.532-1.227-1.915-1.96-2.143-.817-.255-.94-.354-.94-.757a.725.725,0,0,1,1.45,0h1.45a2.171,2.171,0,0,0-1.45-2.041V1.525A4.345,4.345,0,0,1,327.854,6.529Z",
    transform: "translate(-314.351 -0.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(30.45 15.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M349.01,181.08a5.8,5.8,0,0,0-11.5,0h-1.5v1.45h1.5a5.8,5.8,0,0,0,11.5-1.455Zm-5.754,2.9a.726.726,0,0,1-.725-.725h-1.45a2.171,2.171,0,0,0,1.45,2.041v.793a4.345,4.345,0,0,1,0-8.569v.793a2.171,2.171,0,0,0-1.45,2.041c0,1.53,1.226,1.912,1.958,2.141.818.255.942.355.942.759A.726.726,0,0,1,343.256,183.985Zm4.29-1.456a4.344,4.344,0,0,1-3.565,3.565V185.3a2.171,2.171,0,0,0,1.45-2.041c0-1.532-1.227-1.915-1.96-2.143-.817-.255-.94-.354-.94-.757a.725.725,0,0,1,1.45,0h1.45a2.171,2.171,0,0,0-1.45-2.041v-.793A4.345,4.345,0,0,1,347.546,182.529Z",
    transform: "translate(-336.006 -176.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(0 15.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M11.55,181.125a5.8,5.8,0,1,0,0,1.45h1.5v-1.45Zm-5.75,2.9a.725.725,0,0,1-.725-.725H3.625a2.171,2.171,0,0,0,1.45,2.041v.793a4.345,4.345,0,0,1,0-8.569v.793a2.171,2.171,0,0,0-1.45,2.041c0,1.53,1.226,1.912,1.958,2.141.818.255.942.355.942.759A.725.725,0,0,1,5.8,184.025Zm4.29-1.456a4.345,4.345,0,0,1-3.565,3.565v-.793a2.172,2.172,0,0,0,1.45-2.041c0-1.532-1.227-1.915-1.96-2.143-.817-.255-.94-.354-.94-.757a.725.725,0,1,1,1.45,0h1.45a2.171,2.171,0,0,0-1.45-2.041v-.793A4.345,4.345,0,0,1,10.09,182.569Z",
    transform: "translate(0 -176.054)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(27.73 28.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M318.647,318.78a5.785,5.785,0,0,0-6.963,1.227l-4.609-5.267-1.092.955,4.838,5.53a5.8,5.8,0,1,0,7.825-2.445Zm-2.693,7.313a.726.726,0,0,1-.725-.725h-1.45a2.171,2.171,0,0,0,1.45,2.041v.793a4.345,4.345,0,0,1,0-8.569v.793a2.172,2.172,0,0,0-1.45,2.041c0,1.53,1.226,1.912,1.958,2.141.818.255.942.355.942.759A.726.726,0,0,1,315.954,326.093Zm4.29-1.456a4.344,4.344,0,0,1-3.565,3.565v-.793a2.171,2.171,0,0,0,1.45-2.041c0-1.532-1.227-1.915-1.96-2.143-.817-.255-.94-.354-.94-.757a.725.725,0,0,1,1.45,0h1.45a2.171,2.171,0,0,0-1.45-2.041v-.793A4.345,4.345,0,0,1,320.244,324.637Z",
    transform: "translate(-305.983 -314.74)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(0 28.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M15.707,315.081l-.954-1.091-5.364,4.694a5.834,5.834,0,1,0,1.018,1.035Zm-9.9,10.33a.725.725,0,0,1-.725-.725H3.629a2.171,2.171,0,0,0,1.45,2.041v.793a4.345,4.345,0,0,1,0-8.569v.793a2.172,2.172,0,0,0-1.45,2.041c0,1.53,1.226,1.912,1.958,2.141.818.255.942.355.942.759A.725.725,0,0,1,5.8,325.411Zm4.29-1.456a4.345,4.345,0,0,1-3.565,3.565v-.793a2.171,2.171,0,0,0,1.45-2.041c0-1.532-1.227-1.915-1.96-2.143-.817-.255-.94-.354-.94-.757a.725.725,0,1,1,1.45,0h1.45a2.171,2.171,0,0,0-1.45-2.041v-.793A4.345,4.345,0,0,1,10.094,323.955Z",
    transform: "translate(-0.004 -313.99)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(0 0.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M10.348,9.519A5.838,5.838,0,1,0,9.31,10.535l4.5,5.14L14.9,14.72ZM5.8,8.1a.725.725,0,0,1-.725-.725H3.63A2.171,2.171,0,0,0,5.08,9.416v.793a4.345,4.345,0,0,1,0-8.569v.793A2.172,2.172,0,0,0,3.63,4.475c0,1.53,1.226,1.912,1.958,2.141.818.255.942.355.942.759A.725.725,0,0,1,5.8,8.1Zm4.29-1.456A4.345,4.345,0,0,1,6.53,10.209V9.416A2.172,2.172,0,0,0,7.98,7.375c0-1.532-1.227-1.915-1.96-2.143-.817-.255-.94-.354-.94-.757a.725.725,0,1,1,1.45,0H7.98A2.172,2.172,0,0,0,6.53,2.433V1.64A4.345,4.345,0,0,1,10.095,6.644Z",
    transform: "translate(-0.005 -0.136)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.95f43c744f48cd3bb1832b367cea6c11.svg";
export { ForwardRef as ReactComponent };